import Card from "@/components/common/Card";
import IconPicker from "@/components/common/IconPicker";
import { STATUSES } from "./campaignFormUtils";

export default function Step1Basics({ form, onFieldChange, canEditStatus }) {
  return (
    <Card className="builder-form flex flex-col gap-5">
      <div className="builder-grid two-columns">
        <div className="form-group-modal">
          <label htmlFor="campaign-name">Campaign name</label>
          <input
            id="campaign-name"
            value={form.name}
            onChange={(event) => onFieldChange("name", event.target.value)}
            placeholder="e.g. Spring Awareness Push"
            required
          />
        </div>
        <div className="form-group-modal">
          <label htmlFor="campaign-status">Status</label>
          <select
            id="campaign-status"
            value={form.status}
            onChange={(event) => onFieldChange("status", event.target.value)}
            disabled={!canEditStatus}
          >
            {/* Moderation-driven statuses are shown but not selectable. */}
            {!STATUSES.some((s) => s.value === form.status) && (
              <option value={form.status} disabled>
                {form.status === "pending"
                  ? "Pending (moderation)"
                  : form.status === "approved"
                    ? "Approved"
                    : form.status}
              </option>
            )}
            {STATUSES.map((status) => (
              <option key={status.value} value={status.value}>
                {status.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group-modal">
        <IconPicker
          label="Icon"
          value={form.icon ?? ""}
          onChange={(next) => onFieldChange("icon", next || null)}
        />
      </div>

      <div className="form-group-modal">
        <label htmlFor="campaign-description">Description</label>
        <textarea
          id="campaign-description"
          value={form.description}
          onChange={(event) => onFieldChange("description", event.target.value)}
          placeholder="Short description, goals, or context for the campaign…"
          rows={3}
        />
      </div>

      <div className="builder-grid two-columns">
        <div className="form-group-modal">
          <label htmlFor="campaign-start-date">Start date</label>
          <input
            id="campaign-start-date"
            type="date"
            value={form.startDate ?? ""}
            onChange={(event) => onFieldChange("startDate", event.target.value)}
          />
        </div>
        <div className="form-group-modal">
          <label htmlFor="campaign-end-date">End date</label>
          <input
            id="campaign-end-date"
            type="date"
            value={form.endDate ?? ""}
            onChange={(event) => onFieldChange("endDate", event.target.value)}
          />
        </div>
      </div>
    </Card>
  );
}
